import { useState } from "react"
import { useAutoAnimate } from "@formkit/auto-animate/react"
import MobileMenu from "./MobileMenu"

const Header = ({ isPromoOver = false, showPrescreen = false, page = "" }) => {
	const [showMenu, setShowMenu] = useState(false)
	const [animationRef] = useAutoAnimate<HTMLDivElement>()

	function scrollToAnchor(anchor) {
		setTimeout(() => {
			try {
				const doc: any = document
				const { top } = doc.querySelector(".js-" + anchor).getBoundingClientRect()

				window.scrollTo({
					top: top + window.scrollY,
					left: 0,
					behavior: "smooth",
				})

				try {
					// eslint-disable-next-line
					let dataLayer = window["dataLayer"] || []
					dataLayer.push({ event: "header", link: anchor })
				} catch (e) {}
			} catch (error) {}
		}, 300)
	}

	return (
		<>
			<div ref={animationRef}>{showMenu && <MobileMenu setShowMenu={setShowMenu} isPromoOver={isPromoOver} scrollToAnchor={scrollToAnchor} />}</div>
			{page === "start" ? (
				<div className="relative">
					<picture>
						<source media="(min-width: 640px)" srcSet={"/images/header_bg_startpage.png"} />
						<img src={"/images/header_bg_mobile.png"} className=" w-full " alt="" />
					</picture>

					<a href="https://www.dm.de/store" target="_blank" className="absolute left-[3%] top-[92%] block h-[6%] w-[44%]   sm:left-[23%] sm:top-[90%]  sm:h-[7%] sm:w-[14%]"></a>
					<a
						href="https://www.dm.de/marken/hawaiian-tropic-66910"
						target="_blank"
						className="absolute left-[53%] top-[92%] block h-[6%] w-[44%]   sm:left-[64%] sm:top-[90%]  sm:h-[7%] sm:w-[14%]"
					></a>
				</div>
			) : page === "promosoon" ? (
				<picture>
					<source media="(min-width: 640px)" srcSet={"/images/promosoon.png"} />
					<img src={"/images/promosoon-mobile.png"} className=" w-full " alt="" />
				</picture>
			) : (
				<picture>
					<source media="(min-width: 640px)" srcSet={"/images/header_bg_main.png"} />
					<img src={"/images/header_bg_main_mobile.png"} className=" w-full " alt="" />
				</picture>
			)}
		</>
	)
}

export default Header
